import posthog from 'posthog-js'
import { sanitizeProperties as posthogSanitizeProperties } from '@/lib/posthog/scrub'

// PostHog ingest is routed through a same-origin Next.js rewrite (/ingest/*
// → us.i.posthog.com) so events from users running uBlock / Brave Shields /
// AdGuard still land. ui_host stays on the canonical PostHog host so deep
// links (toolbar, replay viewer) resolve to the dashboard, not our app.
const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: '/ingest',
    ui_host: 'https://us.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: 'history_change',
    // PostHog auto-captures unhandled JS errors as `$exception` events via
    // window.onerror + unhandledrejection listeners. global-error.tsx ALSO
    // calls posthog.captureException explicitly because React render errors
    // caught by error boundaries don't always reach window.onerror — the
    // boundary catch is the guarantee. PostHog dedupes by stack-trace hash
    // so any happy-path overlap is harmless.
    capture_exceptions: true,
    // Privacy default for Baohua: family text content (story drafts, chat
    // transcripts, member names, child names) is private per CLAUDE.md.
    // Autocapture would record element text on every click; we keep it off
    // and rely on the explicit `posthog.capture()` calls in the funnel
    // events instead. dead-clicks captures element text for the same reason.
    autocapture: false,
    capture_dead_clicks: false,
    // Session replay sampling is set in the PostHog project; the client
    // respects whatever is configured. The masking config below ensures
    // family content never reaches the recorder, regardless of sampling.
    // worker-src 'self' blob: in next.config.ts CSP exists for the replay
    // worker — keep that directive when editing CSP.
    session_recording: {
      // maskAllInputs covers <input>; maskTextSelector: '*' covers
      // <textarea>, contenteditable, and rendered DOM text (story pages,
      // chat, the book editor canvas). Without it, replay records family
      // story text verbatim.
      maskAllInputs: true,
      maskTextSelector: '*',
      maskInputOptions: { password: true, email: true },
      recordCrossOriginIframes: false,
      // #229: rrweb's CSS inlining calls new Function() to parse
      // stylesheets, which violates the production CSP (no 'unsafe-eval'
      // in script-src). Mobile Safari enforces this strictly, triggering
      // EvalError for ~6 users on /login and /signup. Disabling
      // inlineStylesheet makes rrweb reference stylesheets via <link>
      // instead of inlining them — replay fidelity is marginally lower
      // for dynamic styles but the recorder no longer requires eval.
      inlineStylesheet: false,
    },
    disable_session_recording: false,
    // sanitize_properties runs on every event path (capture, $pageview,
    // $exception autocapture, replay decide payloads). before_send only
    // covers capture-bound events, so we use sanitize_properties as the
    // single scrub point — running both duplicates regex work for no gain.
    sanitize_properties: posthogSanitizeProperties,
  })
}
